import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../../common/CreateSurveyProps';
import { EditObject, MoveDirection } from '../../../common/constants';
import { ApplicationState } from '../../../store';
import * as CreateSurveyStore from '../../../store/CreateSurvey';
import { McqOptionModel } from '../../../models/mcq-option.model';
import produce from 'immer';

export interface iState {
    validationChecked: boolean,
    generalErrorMessage: string,

    isOtherExists: number, //-1 = unknown, 0 = not exists, 1 = exists, 2 = more than 2 exists
    mcqInsertIndex: number,
    editOption: McqOptionModel,
    mcqEnglishText: string,
    mcqFrenchText: string,
}

class Mcq extends React.Component<CreateSurveyProps, iState> {
    private mcqEnglishInput: React.RefObject<HTMLTextAreaElement>;
    
    state = {
        validationChecked: false,
        generalErrorMessage: '',
        isOtherExists: -1,
        mcqInsertIndex: -1,
        editOption: new McqOptionModel(),
        mcqEnglishText: '',
        mcqFrenchText: '',
    }

    constructor(props: any) {
        super(props);
           
        this.mcqEnglishInput = React.createRef();
    }

    public componentDidMount() {
        this.componentDidUpdate();
    }

    public componentDidUpdate() {

		if (this.props.editQuestion.mcqOptions) {
		
			const other = this.props.editQuestion.mcqOptions.filter(a => a.isOther);
		
			const isOtherExists = other.length;

			if (this.state.isOtherExists !== isOtherExists)
				this.setState({...this.state, isOtherExists: isOtherExists});
		}
	}

    handleSelectChangeNumber = (e: React.ChangeEvent<HTMLSelectElement>) => {

        this.props.SetPropertyCreateSurvey(EditObject.Question, e.target.name, '', false, +e.target.value, new Date());
    };

    handleMCQOptionTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.value = e.target.value;

        var option = this.state.editOption;
        var enTxt = this.state.mcqEnglishText;
        var frTxt = this.state.mcqFrenchText;
        
        if (e.target.name === 'optionFrench') {
            option.optionFr = e.target.value;
            frTxt = e.target.value;
        } else {
            option.optionEn = e.target.value;
            enTxt = e.target.value;
        }

        this.setState({...this.state,
            editOption: option,
            mcqEnglishText: enTxt,
            mcqFrenchText: frTxt
        });
    };

    handleMCQOptionCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;

        var option = this.state.editOption;

        option.isOther = e.target.checked;

        this.setState({...this.state, editOption: option});
    };

    AddOrUpdateOptions = () => {
      
        const option = {...this.state.editOption};

        if (option.optionEn.replace(/ /g, '') !== '' &&
            option.optionFr.replace(/ /g, '') !== '') {

            let options = [...this.getMcqOptions()];

            let newOrModifiedOptions = this.generateMcqOptions();

            if (this.state.mcqInsertIndex < 0) {

                options.push(newOrModifiedOptions[0]);

            } else {

                options[this.state.mcqInsertIndex] = newOrModifiedOptions[0];

            }

            newOrModifiedOptions.shift();

            
            options = options.concat(newOrModifiedOptions);


            this.setState({...this.state,
                mcqInsertIndex: -1,
                editOption: new McqOptionModel()});

            this.UpdateMcqOption(options);
         }

        if (this.mcqEnglishInput.current != null) {
            this.mcqEnglishInput.current.focus();
        }
    }

    StartMcqOptionEdit = (index: number) => {

        var option = {...this.getMcqOptions()[index]};

        this.setState({...this.state,
                            editOption: option,
                            mcqInsertIndex: index,
                            mcqEnglishText: option.optionEn,
                            mcqFrenchText: option.optionFr
                        });

        if (this.mcqEnglishInput.current != null) {
            this.mcqEnglishInput.current.focus();
        }
    }

    DeleteMcqOption = (index: number) => {
        
        this.setState(
            produce( this.state, draftState => {

                if (index === this.state.mcqInsertIndex) {
                
                     draftState.mcqInsertIndex = -1;
                    draftState.editOption = new McqOptionModel();
                
                } else if (index < this.state.mcqInsertIndex) {
 
                    draftState.mcqInsertIndex = this.state.mcqInsertIndex -1;
                
                }
               
            }));

            const options = [...this.getMcqOptions()];

            options.splice(index, 1);

            this.UpdateMcqOption(options);
    }
    
    ChangePositionMcqOption = (index: number, direction: MoveDirection) => {
        const temArry = [...this.getMcqOptions()];

        if ((index > 0 && index < temArry.length -1) ||
            (index === 0 && direction === MoveDirection.Down) ||
            (index+1 === temArry.length && direction === MoveDirection.Up)) {
                
            // let subtract = 0;
            // let add = 0;
            let tmpOptn: McqOptionModel = {...temArry[index]};

            if (direction === MoveDirection.Up) {
                // subtract = 2;
                // add = 1;

                temArry[index] = {...temArry[index - 1]};
                temArry[index -1 ] = tmpOptn;
            } else {
                // subtract = 1;
                // add = 2;

                temArry[index] = {...temArry[index + 1]};
                temArry[index + 1] = tmpOptn;
            }

            this.setState(
                {...this.state,
                    editOption: new McqOptionModel(),
                    mcqInsertIndex: -1
                });

            this.UpdateMcqOption(temArry);

        }
    }

    UpdateMcqOption(options:McqOptionModel[]){
     
        this.props.UpdateMcqOption(
            produce(options, draftState => {
                for(let i =0; i < options.length; i++) {
                    draftState[i].sequence = i;
                }
            })
        );
    }

    getMcqOptions() : McqOptionModel[] {
        return (this.props.editQuestion.mcqOptions || []);
    }

    generateMcqOptions() : McqOptionModel[] {
        let enArr = this.state.mcqEnglishText.split('\n');
        enArr = enArr.map(e => e.trim()).filter(x => x !== '');

        let frArr = this.state.mcqFrenchText.split('\n');
        frArr = frArr.map(e => e.trim()).filter(x => x !== '');

        let result: McqOptionModel[] = [];
        
        for(let i = 0; i < enArr.length && i < frArr.length; i++) {
            const tmp = new McqOptionModel();
            tmp.optionEn = enArr[i];
            tmp.optionFr = frArr[i];
            result.push(tmp);
        }

        if (result.length > 0 && this.state.editOption.isOther) {
            let lastOption = result.pop();
            if (lastOption) {
                lastOption.isOther = this.state.editOption.isOther;
            
                result.push(lastOption);
            }
        }

        return result;
    }

    render() {
        return (
            <>
                <div className="row g-3 mb-2">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">MCQ options (one option per line):</label>
                        <textarea
                            name="0-optionEnglish"
                            value={this.state.editOption.optionEn}
                            className="form-control"
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            placeholder="English"
                            onChange={this.handleMCQOptionTextChange}
                            ref={this.mcqEnglishInput}
                            required></textarea>
                    </div>
                </div>
                <div className="row g-3 mb-2">
                    <div className='col-sm-12'>
                        <textarea
                            name="optionFrench"
                            value={this.state.editOption.optionFr}
                            className="form-control"
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            placeholder="French"
                            onChange={this.handleMCQOptionTextChange}
                            required></textarea>
                    </div>
                </div>
                <div className="row g-3 mb-2">
                    <div className='col-sm-12 col-md-6'>
                        <div className="form-check">
                            <input type="checkbox"
                                className="form-check-input"
                                disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                name="isOther"
                                id="isOther"
                                checked={this.state.editOption.isOther}
                                onChange={this.handleMCQOptionCheckboxChange}
                                />
                            <label className="form-check-label" htmlFor="isOther">Is Other(last option in the entry will be set as other)</label>
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                    <button
                            className="btn btn-warning"
                            onClick={() => this.AddOrUpdateOptions()}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}>{ this.state.mcqInsertIndex >=0 ? 'Update' : 'Add' }</button>
                    </div>
                </div>
                <div className="row g-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>English</th>
                                <th>French</th>
                                <th>Other</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.getMcqOptions().map((item, index) => {
                                return (<tr key={index}>
                                    <td>{item.optionEn}</td>
                                    <td>{item.optionFr}</td>
                                    <td>{item.isOther ? 'Yes' : 'No'}</td>
                                    <td>
                                        <button className="btn btn-warning"
                                            disabled={index === 0 || this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                            onClick={() => this.ChangePositionMcqOption(index, MoveDirection.Up)}>Up
                                        </button>&nbsp;<button
                                        className="btn btn-warning"
                                        disabled={index === this.getMcqOptions().length-1 || this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                            onClick={() => this.ChangePositionMcqOption(index, MoveDirection.Down)}>Down
                                        </button>&nbsp;<button
                                        className="btn btn-warning" onClick={() => this.StartMcqOptionEdit(index)}
                                        disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}>Edit
                                        </button>&nbsp;<button
                                        className="btn btn-outline-danger float-end" onClick={() => this.DeleteMcqOption(index)}
                                        disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}>Delete</button>
                                    </td>
                                    </tr>
                                    )
                            })}
                        </tbody>
                    </table>
                </div>

                <div className="row g-3">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Min Selectable MCQ:</label>
                        <select className="form-select"
                            onChange={this.handleSelectChangeNumber}
                            defaultValue={this.props.editQuestion.minMcqValues}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='minMcqValues'>
                        <option key="-1" value="-1">[Not defined]</option>
                            {this.getMcqOptions().map((t, i) => {
                                return(<option key={i+1+'min'} value={i+1}>{i+1}</option>) 
                                })}
                        </select>
                        {/* {(this.state.validationChecked && this.props.editQuestion.questionTypeId <= 0) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>} */}
                    </div>
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Max Selectable MCQ:</label>
                        <select className="form-select"
                            onChange={this.handleSelectChangeNumber}
                            defaultValue={this.props.editQuestion.maxMcqValues}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            name='maxMcqValues'>
                            <option key="-1" value="-1">[Not defined]</option>
                            {this.getMcqOptions().map((t, i) => {
                                return(<option key={i+1+'max'} value={i+1}>{i+1}</option>) 
                                })}
                        </select>
                        {/* {(this.state.validationChecked && this.props.editQuestion.questionTypeId <= 0) && <div className="invalid-feedback d-block pt-1 pb-2">Required field</div>} */}
                    </div>
                </div>
            </>
        );

    }

};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Mcq as any);
